
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/groupPurchases/otp",
      function () {
        return require("private-next-pages/groupPurchases/otp.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/groupPurchases/otp"])
      });
    }
  